<template>
    <v-row justify="center" align="center">
        <v-col cols="auto">
            <v-btn x-small text fab color="grey" @click="goPrevious"> <v-icon>mdi-chevron-left</v-icon> </v-btn>
        </v-col>
        <v-col cols="auto"> {{ year }}년 {{ week }}번째 주 </v-col>
        <v-col cols="auto">
            <v-btn x-small text fab color="grey" @click="goNext"> <v-icon>mdi-chevron-right</v-icon> </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import dayjs from "dayjs";
export default {
    props: {
        value: { type: String, default: Date.now().toDate() }, //date
    },
    computed: {
        year() {
            return dayjs(this.value).year();
        },
        week() {
            return dayjs(this.value).week();
        },
    },
    methods: {
        goPrevious() {
            this.$emit("input", dayjs(this.value).subtract(7, "days").toISOString().toDate());
        },
        goNext() {
            this.$emit("input", dayjs(this.value).add(7, "days").toISOString().toDate());
        },
    },
};
</script>

<style>
</style>